import { render, staticRenderFns } from "./FrontWidgetField.vue?vue&type=template&id=01f07656&"
import script from "./FrontWidgetField.vue?vue&type=script&lang=js&"
export * from "./FrontWidgetField.vue?vue&type=script&lang=js&"
import style0 from "./FrontWidgetField.vue?vue&type=style&index=0&id=01f07656&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports